import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=854c0a82&scoped=true&"
import script from "./vote.vue?vue&type=script&lang=js&"
export * from "./vote.vue?vue&type=script&lang=js&"
import style0 from "./vote.vue?vue&type=style&index=0&id=854c0a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854c0a82",
  null
  
)

export default component.exports